/**
 * ? @description : Primary Information Component
 */

// Dependencies
import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import Axios from "../../../../axios/Axios";
import { LoadingButton } from "@mui/lab";
import { Snackbar } from "@mui/material";
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../../redux/features/appSlice";
import Alert from "@mui/material/Alert";
export default function PrimaryInfo({
  formData,
  setFormData,
  validationRes,
  setValidationRes,
}) {
  const dispatch = useDispatch();
  const [otp, setOtp] = useState("");
  const [alert, setAlert] = useState({
    open:false,
    message:''
  });
  const chosenLanguages = [
    formData.spoke_lang_1,
    formData.spoke_lang_2,
    formData.spoke_lang_3,
    formData.spoke_lang_4,
    formData.spoke_lang_5,
    formData.spoke_lang_6,
  ].filter((data) => data);

  const checkInvalidEmail = (email) => {
    var pattern = new RegExp(
      /^(([\w.+-]+)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    );
    var result = pattern.test(email);
    return !result;
  };

  const [isVerifyOtpTriggered, setIsVerifyOtpTriggered] = useState({
    isSuccess: false,
    isLoading: false,
    isError: false,
    data: null,
  });

  const [verifyOtp, setVerifyOtp] = useState({
    isLoading: false,
    isError: false,
    isSuccess: false,
    data: null,
  });

  const [isEmailVerified, setEmailVerified] = useState({
    isLoading: false,
    isError: false,
    isSuccess: false,
    data: null,
  });

  const triggerOTPRequest = async () => {
    try {
      setIsVerifyOtpTriggered((prev) => ({ ...prev, isLoading: true }));

      let options = {
        method: "POST",
        url: "/teacher/send/otp",
        auth: true,
        data: {
          email: formData.email,
          is_teacher: true,
        },
      };

      const response = await Axios(
        options.method,
        options.url,
        options.auth,
        options.data
      );

      if (response.status === 200) {
        setIsVerifyOtpTriggered((prev) => ({
          ...prev,
          isLoading: false,
          isError: false,
          isSuccess: true,
          data: response.data,
        }));
        dispatch(
          showSnackbar({
            message: "OTP sent successfully, Please check your Email",
            severity: "success",
          })
        );
      }
    } catch (error) {
      console.log(error);
      setIsVerifyOtpTriggered((prev) => ({
        ...prev,
        isLoading: false,
        isError: true,
        data: null,
        isSuccess: false,
      }));
      dispatch(
        showSnackbar({
          message: error?.data?.message,
          severity: "error",
        })
      );
    }
  };

  useEffect(() => {
    if (otp.length === 6) {
      (async () => {
        try {
          setVerifyOtp((prev) => ({
            ...prev,
            isLoading: true,
            isError: false,
            data: null,
            isSuccess: false,
          }));

          let options = {
            method: "POST",
            url: "/teacher/verify/email",
            auth: true,
            data: {
              email: formData.email,
              otp: otp,
            },
          };

          const response = await Axios(
            options.method,
            options.url,
            options.auth,
            options.data
          );

          if (response.status === 200) {
            setVerifyOtp((prev) => ({
              ...prev,
              isLoading: false,
              isError: false,
              isSuccess: true,
              data: response.data,
            }));
            setFormData((prev) => ({ ...prev, isOTPVerified: true }));
            dispatch(
              showSnackbar({
                message: "OTP Verified Successfully",
                severity: "success",
              })
            );
          }
        } catch (error) {
          console.log(error);
          setVerifyOtp((prev) => ({
            ...prev,
            isLoading: false,
            isError: true,
            data: null,
            isSuccess: false,
          }));
          dispatch(
            showSnackbar({
              message: error?.data?.message,
              severity: "error",
            })
          );
        }
      })();
    }
  }, [otp]);

  useEffect(() => {
    if (verifyOtp.isSuccess) {
      setValidationRes({
        ...validationRes,
        isInvalidOTP: false,
      });
    }
  }, [verifyOtp.isSuccess,]);

  useEffect(() => {
    setFormData((prev) => ({ ...prev, isOTPVerified: false }));
    setOtp("");
    setIsVerifyOtpTriggered((prev) => ({
      ...prev,
      isLoading: false,
      isError: false,
      data: null,
      isSuccess: false,
    }));
    setVerifyOtp((prev) => ({
      ...prev,
      isLoading: false,
      isError: false,
      data: null,
      isSuccess: false,
    }));
  }, [formData.email]);

  useEffect(() => {
    if (!checkInvalidEmail(formData.email)) {
      (async () => {
        try {
          setEmailVerified((prev) => ({
            ...prev,
            isLoading: true,
            isError: false,
            data: null,
            isSuccess: false,
          }));

          let options = {
            method: "POST",
            url: "/teacher/check/email/verification",
            auth: true,
            data: {
              email: formData.email,
              is_teacher: true,
            },
          };

          const response = await Axios(
            options.method,
            options.url,
            options.auth,
            options.data
          );

          if (response.status === 200) {
            setEmailVerified((prev) => ({
              ...prev,
              isLoading: false,
              isError: false,
              isSuccess: true,
              data: response.data.verifiedEmail ? "verified" : "unverified",
            }));
            setFormData((prev) => ({
              ...prev,
              isOTPVerified: response.data.verifiedEmail,
            }));
          }
        } catch (error) {
          setAlert({open:true,message:error?.data?.message});
          // window.alert(error?.data?.message)
          showSnackbar({
            message: "error",
            severity: "error",
          });
          console.log(error);
          setEmailVerified((prev) => ({
            ...prev,
            isLoading: false,
            isError: true,
            data: null,
            isSuccess: false,
          }));
        }
      })();
    } else {
      setEmailVerified((prev) => ({
        ...prev,
        isLoading: false,
        isError: false,
        isSuccess: false,
        data: false,
      }));
      setFormData((prev) => ({ ...prev, isOTPVerified: false }));
    }
  }, [formData.email]);

  return (
    <div>
<Snackbar
  open={alert.open}
  autoHideDuration={3000}
  onClose={() => setAlert((prev) => ({ ...prev, open: false }))}
  anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
>
  <Alert
    severity={'error'}
    onClose={() => setAlert((prev) => ({ ...prev, open: false }))}
    sx={{ width: '100%' }}
  >
    {alert.message}
  </Alert>
</Snackbar>
      <Form>
        <Form.Group className="mb-3 form-info">
          <Form.Label>
            Name <span style={{ color: "red" }}>*</span>
          </Form.Label>

          <Form.Control
            type="name"
            name="teacher_name"
            placeholder="Enter Your Name"
            // style={{ width: "250px" }}
            value={formData.teacher_name}
            onChange={(event) => {
              setFormData({ ...formData, teacher_name: event.target.value });
              setValidationRes({
                ...validationRes,
                isInvalidTeacherName: false,
                isInvalidTeacherNameFormate: false,
              });
            }}
            isInvalid={
              validationRes.isInvalidTeacherName ||
              validationRes.isInvalidTeacherNameFormate
            }
          />
          <Form.Text>
            Note:- Only alphabetical letters of max 50 characters are allowed{" "}
          </Form.Text>

          <Form.Control.Feedback type="invalid">
            {validationRes.isInvalidTeacherName
              ? "Name is mandatory and should be less than 50 characters."
              : ""}
            {validationRes.isInvalidTeacherNameFormate
              ? "The volunteer name should consist only of alphabetical values."
              : ""}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group className="mb-3 form-info">
          <Form.Label>
            Mobile Number <span style={{ color: "red" }}>*</span>
          </Form.Label>

          <Form.Control
            type="tel"
            name="contactno"
            placeholder="Enter Your Number"
            // style={{ width: "250px" }}
            value={formData.contactno}
            onChange={(event) => {
              setFormData({ ...formData, contactno: event.target.value });
              setValidationRes({
                ...validationRes,
                isInvalidTeacherMobileNumber: false,
                isInvalidTeacherMobileNumberFormate: false,
              });
            }}
            isInvalid={
              validationRes.isInvalidTeacherMobileNumber ||
              validationRes.isInvalidTeacherMobileNumberFormate
            }
          />

          <Form.Control.Feedback type="invalid">
            {validationRes.isInvalidTeacherMobileNumber
              ? "Mobile number must contains 10 digits."
              : ""}
            {validationRes.isInvalidTeacherMobileNumberFormate
              ? "Volunteer phone number is not valid"
              : ""}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group className="mb-3 form-info">
          <Form.Label>
            Email ID <span style={{ color: "red" }}>*</span>
          </Form.Label>

          <Form.Control
            type="email"
            name="email"
            placeholder="Your Email Id"
            // style={{ width: "250px" }}
            value={formData.email}
            onChange={(event) => {
              setFormData({
                ...formData,
                email: event.target.value.toLocaleLowerCase(),
              });
              setIsVerifyOtpTriggered((prev) => ({
                ...prev,
                isLoading: false,
                isError: false,
                isSuccess: false,
                data: null,
              }));
              setValidationRes({
                ...validationRes,
                isInvalidTeacherMailId: false,
              });
            }}
            isInvalid={validationRes.isInvalidTeacherMailId}
          />
          {isEmailVerified.data === "unverified" && !formData.isOTPVerified && (
            <LoadingButton
              onClick={triggerOTPRequest}
              loading={isVerifyOtpTriggered.isLoading}
              className="mt-1"
              size="small"
              type="button"
            >
              {isVerifyOtpTriggered.isSuccess ? "Resend" : "Verify OTP"}
            </LoadingButton>
          )}

          {formData.isOTPVerified && (
            <span className="mt-1 text-success">
              Email Verified Successfully
            </span>
          )}

          <Form.Control.Feedback type="invalid">
            Enter valid Email Id
          </Form.Control.Feedback>
        </Form.Group>

        {isVerifyOtpTriggered.isSuccess && !formData.isOTPVerified && (
          <Form.Group className="mb-3 form-info">
            <Form.Label>
              Enter OTP <span style={{ color: "red" }}>*</span>
            </Form.Label>

            <Form.Control
              type="text"
              name="otp"
              placeholder="Enter OTP"
              value={otp}
              isInvalid={validationRes.isInvalidOTP}
              onChange={(e) => {
                setValidationRes({
                  ...validationRes,
                  isInvalidOTP: false,
                });
                if (e.target.value.length <= 6) {
                  setOtp(e.target.value);
                }
              }}
              onKeyDown={(e) => {
                if (otp.length >= 6 && e.key !== "Backspace") {
                  e.preventDefault();
                }
              }}
            />

            {verifyOtp.isLoading && <LoadingButton loading></LoadingButton>}
            {verifyOtp.isSuccess && (
              <span className="mt-1 text-success">
                Email Verified Successfully
              </span>
            )}
            {verifyOtp.isError && (
              <span className="mt-1 text-danger">Invalid OTP</span>
            )}

            <Form.Control.Feedback type="invalid">
              Email must be verified
            </Form.Control.Feedback>
          </Form.Group>
        )}

        <Form.Group className="mb-3 form-info">
          <Form.Label>
            Spoken Language - 1 <span style={{ color: "red" }}>*</span>
          </Form.Label>

          {/* <Form.Control
            type="text"
            name="spoke_lang_1"
            placeholder="First Language"
            value={formData.spoke_lang_1}
            onChange={(event) => {
              setFormData({ ...formData, spoke_lang_1: event.target.value });
              setValidationRes({
                ...validationRes,
                isInvalidSpokenLanguage1: false,
              });
            }}
            isInvalid={validationRes.isInvalidSpokenLanguage1}
          /> */}

          <Form.Select
            aria-label="Default select example"
            defaultValue=""
            // style={{ width: "250px" }}
            value={formData.spoke_lang_1}
            onChange={(event) => {
              setFormData({ ...formData, spoke_lang_1: event.target.value });
              setValidationRes({
                ...validationRes,
                isInvalidSpokenLanguage1: false,
              });
            }}
            isInvalid={validationRes.isInvalidSpokenLanguage1}
          >
            <option value="">Select one language</option>
            {[
              "English",
              "Hindi",
              "Kannada",
              "Malayalam",
              "Tamil",
              "Telugu",
              "Urdu",
            ].map((item) => (
              <option
                disabled={chosenLanguages.some((data) => data === item)}
                key={`spoken-language-1-${item}`}
                value={item}
              >
                {item}
              </option>
            ))}
          </Form.Select>

          <Form.Control.Feedback type="invalid">
            Spoken Language is mandatory.
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group className="mb-3 form-info">
          <Form.Label>Spoken Language - 2</Form.Label>

          {/* <Form.Control
            type="text"
            name="spoke_lang_2"
            placeholder="Second Language"
            value={formData.spoke_lang_2}
            onChange={(event) => {
              setFormData({ ...formData, spoke_lang_2: event.target.value });
              setValidationRes({
                ...validationRes,
                isInvalidSpokenLanguage2: false,
              });
            }}
            isInvalid={validationRes.isInvalidSpokenLanguage2}
          /> */}

          <Form.Select
            aria-label="Default select example"
            // style={{ width: "250px" }}
            value={formData.spoke_lang_2}
            onChange={(event) => {
              setFormData({ ...formData, spoke_lang_2: event.target.value });
            }}
          >
            <option value="">Select one language</option>
            {[
              "English",
              "Hindi",
              "Kannada",
              "Malayalam",
              "Tamil",
              "Telugu",
              "Urdu",
            ].map((item) => (
              <option
                disabled={chosenLanguages.some((data) => data === item)}
                key={`spoken-language-2-${item}`}
                value={item}
              >
                {item}
              </option>
            ))}
          </Form.Select>
        </Form.Group>

        <Form.Group className="mb-3 form-info">
          <Form.Label>Spoken Language - 3</Form.Label>

          <Form.Select
            aria-label="Default select example"
            // style={{ width: "250px" }}
            value={formData.spoke_lang_3}
            onChange={(event) => {
              setFormData({ ...formData, spoke_lang_3: event.target.value });
            }}
          >
            <option value="">Select one language</option>
            {[
              "English",
              "Hindi",
              "Kannada",
              "Malayalam",
              "Tamil",
              "Telugu",
              "Urdu",
            ].map((item) => (
              <option
                disabled={chosenLanguages.some((data) => data === item)}
                key={`spoken-language-3-${item}`}
                value={item}
              >
                {item}
              </option>
            ))}
          </Form.Select>
        </Form.Group>

        <Form.Group className="mb-3 form-info">
          <Form.Label>Spoken Language - 4</Form.Label>

          <Form.Select
            aria-label="Default select example"
            // style={{ width: "250px" }}
            value={formData.spoke_lang_4}
            onChange={(event) => {
              setFormData({ ...formData, spoke_lang_4: event.target.value });
            }}
          >
            <option value="">Select one language</option>
            {[
              "English",
              "Hindi",
              "Kannada",
              "Malayalam",
              "Tamil",
              "Telugu",
              "Urdu",
            ].map((item) => (
              <option
                disabled={chosenLanguages.some((data) => data === item)}
                key={`spoken-language-4-${item}`}
                value={item}
              >
                {item}
              </option>
            ))}
          </Form.Select>
        </Form.Group>

        <Form.Group className="mb-3 form-info">
          <Form.Label>Spoken Language - 5</Form.Label>

          <Form.Select
            aria-label="Default select example"
            // style={{ width: "250px" }}
            value={formData.spoke_lang_5}
            onChange={(event) => {
              setFormData({ ...formData, spoke_lang_5: event.target.value });
            }}
          >
            <option value="">Select one language</option>
            {[
              "English",
              "Hindi",
              "Kannada",
              "Malayalam",
              "Tamil",
              "Telugu",
              "Urdu",
            ].map((item) => (
              <option
                disabled={chosenLanguages.some((data) => data === item)}
                key={`spoken-language-5-${item}`}
                value={item}
              >
                {item}
              </option>
            ))}
          </Form.Select>
        </Form.Group>

        <Form.Group className="mb-3 form-info">
          <Form.Label>Spoken Language - 6</Form.Label>

          <Form.Select
            aria-label="Default select example"
            // style={{ width: "250px" }}
            value={formData.spoke_lang_6}
            onChange={(event) => {
              setFormData({ ...formData, spoke_lang_6: event.target.value });
            }}
          >
            <option value="">Select one language</option>
            {[
              "English",
              "Hindi",
              "Kannada",
              "Malayalam",
              "Tamil",
              "Telugu",
              "Urdu",
            ].map((item) => (
              <option
                disabled={chosenLanguages.some((data) => data === item)}
                key={`spoken-language-6-${item}`}
                value={item}
              >
                {item}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
      </Form>
    </div>
  );
}
